import React from 'react'

import { PaymentsByMonth } from '../../../../common/generated/residentApiSchemas'
import { TRemittance } from '../../../../common/validations/remittance'

import { useAPIGetContractPaymentsByMonthSuspense } from 'api/apiHooks/useAPIGetContractPaymentsByMonth'
import { useAPIGetContractRemittancesSuspense } from 'api/apiHooks/useAPIGetContractRemittances'
import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

interface Data {
  paymentsByMonth: PaymentsByMonth[]
  remittances: TRemittance[]
}

export const DataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: paymentsByMonth } =
    useAPIGetContractPaymentsByMonthSuspense(currentContractId)
  const { data: remittances } =
    useAPIGetContractRemittancesSuspense(currentContractId)

  return children({ paymentsByMonth, remittances })
}
